<template>
  <div style="background-color:#efeff4">
    <div style="padding:.5rem;">
      <van-field
        v-model="value"
        :type="fieldType"
        :placeholder="placeholder"
        @keyup.enter="keySearch"
        left-icon="search"
        class="field"
      />
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "searchValue",
    event: "onChange"
  },
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    fieldType: {
      type: String,
      default: "text"
    }
  },
  data() {
    return {
      value: "",
      searchValue: ""
    };
  },
  watch: {
    value(newValue) {
      this.$emit("onChange", newValue);
    }
  },
  methods: {
    search() {
      this.$emit("onSearchClick", this.searchValue);
    },
    keySearch() {
      this.$emit("keySearch", this.searchValue);
    }
  }
};
</script>

<style lang="less" scoped>
.field {
  align-items: center;
  height: 2.2rem;
  font-size: 0.94rem;
  border-radius: 0.19rem;
}
</style>
